import { styled } from '@mui/material';

import Box from 'shell/components/Box';
import Stack from 'shell/components/Stack';

const DotProgression = ({ activeStepIndex, numSteps }) => {
    if (!(activeStepIndex >= 0 && activeStepIndex < numSteps)) {
        throw new Error('Shell: "activeStepIndex" out of range in component DotProgression.');
    }
    if (typeof numSteps !== 'number') {
        throw new Error('Shell: "numSteps" must be a number in component DotProgression.');
    }

    return (
        <Stack direction={'row'} spacing={1}>
            {Array(numSteps)
                .fill()
                .map((_, index) => (
                    <CustomBox key={index} active={activeStepIndex === index} />
                ))}
        </Stack>
    );
};

const CustomBox = styled(Box)(({ active, theme }) => {
    return {
        borderRadius: active ? '20px' : '50%',
        width: active ? '23px' : '10px',
        height: '10px',
        background: theme.palette.ensightful.primary[500],
        transition: 'all 0.3s linear',
    };
});

export default DotProgression;
